import { render, staticRenderFns } from "./AffSubWhiteList.vue?vue&type=template&id=11c68fcc&"
import script from "./AffSubWhiteList.vue?vue&type=script&lang=js&"
export * from "./AffSubWhiteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports